{
    "title": "الشكاوى",
    "description": "جميع الشكاوى التي استلمها البنك، في قائمة واحدة.",
    "workspace_title": "مساحة عمل الشكاوى",
    "search_placeholder": "ابحث بالرقم المرجعي أو الموضوع أو النص…",
    "empty_title": "لا توجد شكاوى تطابق هذا العرض",
    "empty_description": "جرّب عرضاً محفوظاً آخر، أو امسح البحث وعوامل التصفية.",
    "reference": "الرقم المرجعي",
    "subject": "الموضوع",
    "customer": "العميل",
    "category": "التصنيف",
    "status": "الحالة",
    "priority": "الأولوية",
    "source": "المصدر",
    "channel": "القناة",
    "outcome": "النتيجة",
    "assignee": "مُسندة إلى",
    "team": "الفريق",
    "branch": "الفرع",
    "product": "المنتج",
    "age": "المدة",
    "logged": "تاريخ التسجيل",
    "resolved": "تمت المعالجة",
    "closed": "مغلقة",
    "unassigned": "غير مُسندة",
    "risk": "المخاطر",
    "views": {
        "label": "العروض المحفوظة",
        "mine": "المسندة إليّ",
        "unassigned": "غير المسندة",
        "breaching_soon": "على وشك التجاوز",
        "breached": "متجاوزة للمدة",
        "escalated": "مصعّدة",
        "awaiting_customer": "بانتظار العميل",
        "high_risk": "عالية المخاطر",
        "open": "جميع المفتوحة"
    },
    "sla": {
        "label": "مستوى الخدمة",
        "due": "الاستحقاق {{when}}",
        "overdue_by": "متأخرة بمقدار {{duration}}",
        "remaining": "متبقٍ {{duration}}",
        "policy": "السياسة",
        "target": "المستهدف {{count}} يوم عمل",
        "target_plural": "المستهدف {{count}} أيام عمل",
        "first_response": "أول رد",
        "first_response_met": "ضمن المدة",
        "first_response_missed": "تجاوز المدة",
        "paused_note": "المؤقت متوقف طالما أن البنك بانتظار رد العميل.",
        "paused_for": "متوقف منذ {{duration}}"
    },
    "thread": {
        "title": "المراسلات",
        "internal_note": "ملاحظة داخلية",
        "internal_badge": "داخلية",
        "from_customer": "من العميل",
        "to_customer": "إلى العميل",
        "ai_drafted": "صيغت بمساعدة الذكاء الاصطناعي",
        "ai_edited": "عُدّلت قبل الإرسال",
        "empty": "لم تتم إضافة أي شيء إلى هذه الشكوى بعد.",
        "note_placeholder": "ملاحظة يراها الزملاء فقط…",
        "reply_placeholder": "ردك على العميل…",
        "add_note": "إضافة ملاحظة",
        "send_reply": "إرسال الرد",
        "note_help": "الملاحظات الداخلية لا تظهر للعميل إطلاقاً.",
        "reply_help": "يُرسل هذا إلى العميل ويظهر في صفحة متابعة شكواه."
    },
    "attachments": {
        "title": "المرفقات",
        "empty": "لا توجد ملفات مرفقة.",
        "pending_scan": "بانتظار الفحص من الفيروسات",
        "unsafe": "محجوب من قِبل برنامج الفحص",
        "from_customer": "أرسله العميل"
    },
    "history": {
        "title": "السجل",
        "automated": "تلقائي",
        "empty": "لم يُسجّل أي نشاط بعد."
    },
    "actions": {
        "log": "تسجيل شكوى",
        "change_status": "تغيير الحالة",
        "assign": "إسناد",
        "reassign": "إعادة الإسناد",
        "unassign": "الإرجاع إلى قائمة الفريق",
        "resolve": "معالجة",
        "close": "إغلاق",
        "reopen": "إعادة فتح",
        "open_customer": "فتح ملف العميل",
        "reason": "السبب",
        "reason_optional": "السبب (اختياري)",
        "reason_placeholder": "ما سبب هذا الإجراء؟",
        "confirm": "تأكيد",
        "cancel": "إلغاء"
    },
    "resolve_dialog": {
        "title": "معالجة الشكوى {{reference}}",
        "description": "يظهر هذا الملخص للعميل في صفحة المتابعة ويُدرج في تقرير البنك المركزي، فاكتبه له لا للملف.",
        "outcome": "النتيجة",
        "summary": "ملخص المعالجة",
        "summary_placeholder": "ما الذي تبيّن، وما الذي قام به البنك…",
        "compensation": "التعويض (ريال عماني)",
        "compensation_help": "اتركه فارغاً إن لم يُدفع تعويض."
    },
    "reopen_dialog": {
        "title": "إعادة فتح الشكوى {{reference}}",
        "description": "تحتفظ الشكوى برقمها المرجعي وبسجلها. تُحتسب إعادة الفتح وتُدرج في التقارير."
    },
    "customer_panel": {
        "title": "العميل",
        "vip": "عميل مميز",
        "requires_assistance": "يحتاج مساعدة",
        "complaints_total": "شكوى واحدة مسجلة",
        "complaints_total_plural": "{{count}} شكاوى مسجلة",
        "open_now": "{{count}} ما زالت مفتوحة",
        "prefers": "يفضّل {{channel}}",
        "language": "يكتب بـ{{language}}"
    },
    "outcomes": {
        "upheld": "مقبولة",
        "partially_upheld": "مقبولة جزئياً",
        "not_upheld": "غير مقبولة",
        "withdrawn": "مسحوبة",
        "duplicate": "مكررة",
        "out_of_scope": "خارج النطاق"
    },
    "ai": {
        "not_analysed": "لم تُحلّل",
        "confidence": "نسبة الثقة {{percent}}٪",
        "overridden": "صحّح الموظف التصنيف",
        "provenance": "اقترحه {{model}}"
    },
    "public": {
        "title": "متابعة شكواك",
        "description": "أدخل الرقم المرجعي الذي زوّدك به البنك. سنرسل رمزاً إلى رقم الهاتف المسجل لديك.",
        "reference_label": "الرقم المرجعي للشكوى",
        "reference_placeholder": "CMP-2026-000000",
        "request_code": "إرسال الرمز",
        "code_label": "رمز التحقق",
        "code_help": "أُرسل إلى {{destination}}. تنتهي صلاحيته خلال {{minutes}} دقائق.",
        "code_help_generic": "في حال كان الرقم المرجعي صحيحاً، فقد أُرسل رمز إلى رقم الهاتف المسجل.",
        "verify": "عرض الحالة",
        "resend": "إرسال رمز آخر",
        "back": "استخدام رقم مرجعي آخر",
        "submitted": "تاريخ التقديم",
        "expected": "متوقعة بحلول",
        "resolution": "ما قام به البنك",
        "updates": "التحديثات",
        "no_updates": "لا توجد تحديثات لعرضها بعد.",
        "confirm_title": "هل عالجت هذه الخطوة شكواك؟",
        "confirm_description": "إخبارنا بالإجابة يساعدنا في الحالتين. وإن لم تُعالَج، تعود الشكوى مباشرة إلى الفريق الذي تولاها.",
        "confirm_yes": "نعم، تمت المعالجة",
        "confirm_no": "لا، أعيدوا فتحها",
        "reopen_reason_label": "ما الذي لم يُعالَج بعد؟",
        "reopen_reason_placeholder": "أخبرنا بما لم يُصحَّح…",
        "reopen_submit": "إعادة فتح شكواي",
        "window_note": "يمكنك الرد حتى تاريخ {{date}}.",
        "confirmed": "شكراً لك. تم إغلاق شكواك.",
        "reopened": "أُعيد فتح شكواك وأُحيلت إلى فريقنا."
    },
    "report": {
        "title": "تقرير البنك المركزي",
        "description": "أعداد الشكاوى ومدد المعالجة والنتائج لفترة التقرير.",
        "period": "الفترة",
        "generated": "صدر {{when}}",
        "total_received": "المستلمة",
        "resolved": "المعالجة",
        "still_open": "ما زالت مفتوحة",
        "reopened": "أُعيد فتحها",
        "escalated": "المصعّدة",
        "by_category": "حسب التصنيف الرقابي",
        "by_product": "حسب المنتج",
        "by_channel": "حسب القناة",
        "by_governorate": "حسب المحافظة",
        "by_branch": "حسب الفرع",
        "ageing": "الأعمار",
        "resolution_times": "مدد المعالجة",
        "outcomes": "النتائج",
        "compensation": "التعويضات",
        "business_hours_note": "تُحتسب مدد المعالجة بساعات العمل وفق تقويم البنك، لا بالوقت المنقضي.",
        "cohort_note": "تُحتسب الشكوى ضمن الفترة التي استُلمت فيها، فلا يمكن لتأخير المعالجة أن ينقلها من شهر سيّئ.",
        "download": "تنزيل CSV"
    },
    "toast": {
        "created": "تم تسجيل الشكوى {{reference}}.",
        "status_updated": "تم تحديث الحالة.",
        "assigned": "تم إسناد الشكوى.",
        "resolved": "تمت معالجة الشكوى.",
        "closed": "تم إغلاق الشكوى.",
        "reopened": "تمت إعادة فتح الشكوى.",
        "note_added": "تمت إضافة الملاحظة.",
        "reply_sent": "تم إرسال الرد."
    },
    "config": {
        "title": "إعدادات الشكاوى",
        "description": "قواعد التوجيه ومستهدفات الخدمة والتصنيفات وتقويم العمل.",
        "routing": "قواعد التوجيه",
        "sla": "مستويات الخدمة",
        "categories": "التصنيفات",
        "calendar": "تقويم العمل",
        "routing_note": "تُقيَّم القواعد بالترتيب وتُطبَّق أول قاعدة مطابقة. القاعدة التي لا تطابق شيئاً إما غير قابلة للوصول أو خاطئة.",
        "sla_note": "يسري تغيير المستهدف على الشكاوى المسجلة من الآن فصاعداً. أما الشكاوى المفتوحة فتحتفظ بالمدة التي حُددت لها.",
        "match_all": "يجب تحقق جميع الشروط",
        "match_any": "يكفي تحقق أي شرط",
        "matches": "مطابقة واحدة",
        "matches_plural": "{{count}} مطابقات",
        "stops": "التوقف هنا",
        "rule_active": "القاعدة مفعّلة",
        "move_up": "تقديم",
        "move_down": "تأخير",
        "default_policy": "الافتراضية",
        "first_response_hours": "أول رد (ساعات)",
        "resolution_hours": "المعالجة (ساعات)",
        "closed": "مغلق",
        "shortened": "ساعات مختصرة",
        "exceptions": "العطل والساعات الخاصة",
        "rule_saved": "تم حفظ قاعدة التوجيه.",
        "rules_reordered": "تم حفظ ترتيب القواعد.",
        "policy_saved": "تم حفظ سياسة مستوى الخدمة."
    }
}
